export default __webpack_public_path__ + "static/media/desktop.6d48cc78.svg";